import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { GlobalVariables } from 'global-variables';


@Injectable({
  providedIn: 'root'
})
export class IntegrationService {

  constructor(
    private http: HttpClient
  ) { }
  private url = GlobalVariables.appURL;

  generateKey(platform: string, storeIdentifier: string) {
    const baseUrl = `${this.url}${platform}`;
    return this.http.post<{ accessKey: string }>(`${baseUrl}/keys`, { storeIdentifier });
  }

  fetchKeys() {
    return this.http.get<{ data: any[] }>(`${this.url}platforms/keys`);
  }

  fetchPlatforms() {
    return this.http.get<{ data: string[] }>(`${this.url}platforms`);
  }

  updatePlatformDetails(
    platform: string,
    id: string,
    payload: { description: string; plugin: string }
  ) {
    return this.http.patch(
      `${this.url}${platform}/keys/${id}`,
      payload
    );
  }
}